import { useEffect, useState } from 'react';
import { api, sessao, ESFERICOS, CILINDRICOS, ADICOES } from '../api';
import { Icone } from '../Icones.jsx';

const vazio = () => ({
  numero_os: '', cliente: '', vendedor: '', loja_id: '',
  armacao: '', lente: '', tratamento1: '', tratamento2: '',
  tipo_armacao: '', largura: '', altura_arm: '', ponte: '', diagonal: '',
  olhos: 'ambos',
  od_esferico: '', od_cilindrico: '', od_eixo: '', od_altura: '', od_dnp: '', od_adicao: '',
  oe_esferico: '', oe_cilindrico: '', oe_eixo: '', oe_altura: '', oe_dnp: '', oe_adicao: '',
  forma_armacao_id: '', observacoes: '',
});

function LinhaOlho({ prefixo, os, set, off }) {
  const sel = (campo, opts) => (
    <select className="select" disabled={off} value={os[campo]} onChange={e => set(campo, e.target.value)} style={{ opacity: off ? .4 : 1 }}>
      {opts.map(o => <option key={o} value={o.replace('+', '')}>{o === '' ? '—' : o}</option>)}
    </select>
  );
  const inp = campo => (
    <input className="input" disabled={off} value={os[campo]} onChange={e => set(campo, e.target.value)} style={{ opacity: off ? .4 : 1 }} />
  );
  return (
    <>
      <div className="olho">{prefixo.toUpperCase()}</div>
      {sel(`${prefixo}_esferico`, ESFERICOS)}
      {sel(`${prefixo}_cilindrico`, CILINDRICOS)}
      {inp(`${prefixo}_eixo`)}
      {inp(`${prefixo}_altura`)}
      {inp(`${prefixo}_dnp`)}
      {sel(`${prefixo}_adicao`, ADICOES)}
    </>
  );
}

export default function NovaOS() {
  const u = sessao.usuario;
  const [os, setOs] = useState(vazio());
  const [formas, setFormas] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [foto, setFoto] = useState(null);
  const [anexos, setAnexos] = useState([]);
  const [msg, setMsg] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    api('/formas').then(setFormas).catch(() => {});
    if (u.perfil === 'admin') api('/lojas').then(setLojas).catch(() => {});
  }, []);

  const set = (campo, v) => setOs(p => ({ ...p, [campo]: v }));
  const odOff = os.olhos === 'esquerdo', oeOff = os.olhos === 'direito';

  const salvar = async () => {
    setMsg(null);
    if (!os.numero_os || !os.cliente)
      return setMsg({ t: 'erro', m: 'Preencha o nº da OS e o nome do cliente.' });
    setSalvando(true);
    try {
      const form = new FormData();
      Object.entries(os).forEach(([k, v]) => form.append(k, v ?? ''));
      if (foto) form.append('foto', foto);
      anexos.forEach(a => form.append('anexos', a));
      await api('/ordens', { method: 'POST', form });
      setMsg({ t: 'ok', m: `OS ${os.numero_os} enviada para a expedição!` });
      setOs(vazio()); setFoto(null); setAnexos([]);
    } catch (e) {
      setMsg({ t: 'erro', m: e.message });
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 14 }}>Nova Ordem de Serviço</h2>
      {msg && <div className={msg.t === 'ok' ? 'sucesso' : 'erro'} style={{ marginBottom: 12 }}>{msg.m}</div>}

      <div className="grid duas-colunas" style={{ gridTemplateColumns: 'minmax(0,1fr) 260px', alignItems: 'start' }}>
        <div className="grid">
          <div className="card">
            <div className="row">
              <div style={{ flex: 1 }}>
                <label className="label">Nº OS *</label>
                <input className="input" style={{ fontWeight: 800 }} value={os.numero_os} onChange={e => set('numero_os', e.target.value)} />
              </div>
              {u.perfil === 'admin' ? (
                <div style={{ flex: 2 }}>
                  <label className="label">Loja</label>
                  <select className="select" value={os.loja_id} onChange={e => set('loja_id', e.target.value)}>
                    <option value="">Selecione…</option>
                    {lojas.filter(l => l.ativo).map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
                  </select>
                </div>
              ) : (
                <div style={{ flex: 2 }}>
                  <label className="label">Loja</label>
                  <input className="input" value={u.loja_nome || ''} disabled />
                </div>
              )}
            </div>
            <div className="row" style={{ marginTop: 10 }}>
              <div style={{ flex: 2 }}>
                <label className="label">Cliente *</label>
                <input className="input" value={os.cliente} onChange={e => set('cliente', e.target.value)} />
              </div>
              <div style={{ flex: 1 }}>
                <label className="label">Vendedor(a)</label>
                <input className="input" value={os.vendedor} onChange={e => set('vendedor', e.target.value)} />
              </div>
            </div>
          </div>

          <div className="card">
            <h3 className="card-title">Produtos / Serviços</h3>
            <div className="grid" style={{ gap: 8 }}>
              <div><label className="label">a) Armação</label><input className="input" value={os.armacao} onChange={e => set('armacao', e.target.value)} /></div>
              <div><label className="label">b) Lente</label><input className="input" value={os.lente} onChange={e => set('lente', e.target.value)} /></div>
              
              <div className="row">
                <div style={{ flex: 1 }}><label className="label">c) Tratamento 1</label><input className="input" value={os.tratamento1} onChange={e => set('tratamento1', e.target.value)} /></div>
                <div style={{ flex: 1 }}><label className="label">d) Tratamento 2</label><input className="input" value={os.tratamento2} onChange={e => set('tratamento2', e.target.value)} /></div>
              </div>
            </div>
          </div>

          <div className="grid duas-colunas" style={{ gridTemplateColumns: '1fr 1fr' }}>
            <div className="card">
              <h3 className="card-title">Tipo de Armação</h3>
              {[['acetato', 'Acetato'], ['metal', 'Metal'], ['metal_nylon', 'Metal / Nylon'], ['parafusado', 'Parafusado']].map(([v, l]) => (
                <label key={v} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '5px 0', cursor: 'pointer' }}>
                  <input type="radio" name="tipo" checked={os.tipo_armacao === v} onChange={() => set('tipo_armacao', v)} style={{ accentColor: 'var(--verde)' }} />{l}
                </label>
              ))}
            </div>
            <div className="card">
              <h3 className="card-title">Medida da Lente / Armação</h3>
              {[['largura', '1 · Largura'], ['altura_arm', '2 · Altura'], ['ponte', '3 · Ponte'], ['diagonal', '4 · Diagonal']].map(([k, l]) => (
                <div key={k} className="row" style={{ marginBottom: 7, justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 13, color: 'var(--cinza)' }}>{l}</span>
                  <input className="input" style={{ width: 80 }} value={os[k]} onChange={e => set(k, e.target.value)} />
                </div>
              ))}
            </div>
          </div>

          <div className="card">
            <h3 className="card-title">Receita</h3>
            <div className="row" style={{ marginBottom: 12 }}>
              {[['ambos', 'Ambos os olhos'], ['direito', 'Olho direito'], ['esquerdo', 'Olho esquerdo']].map(([v, l]) => (
                <label key={v} style={{ display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                  <input type="radio" name="olhos" checked={os.olhos === v} onChange={() => set('olhos', v)} style={{ accentColor: 'var(--verde)' }} />{l}
                </label>
              ))}
            </div>
            <div className="receita-grid">
              <div />
              {['Esférico', 'Cilíndrico (−)', 'Eixo', 'Altura', 'DNP', 'Adição'].map(h => <div key={h} className="cab">{h}</div>)}
              <LinhaOlho prefixo="od" os={os} set={set} off={odOff} />
              <LinhaOlho prefixo="oe" os={os} set={set} off={oeOff} />
            </div>
          </div>

          <div className="card">
            <h3 className="card-title">Observações</h3>
            <textarea className="textarea" rows={2} value={os.observacoes} onChange={e => set('observacoes', e.target.value)} />
            
            <label style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, fontSize: 13, color: 'var(--cinza)', cursor: 'pointer' }}>
              <Icone nome="camera" size={13} /> Fotos (receita, OS física e armação — até 6):
              <input type="file" accept="image/*" multiple
                onChange={e => setAnexos([...e.target.files].slice(0, 6))} />
            </label>
            {anexos.length > 0 && (
              <div style={{ fontSize: 12, color: 'var(--verde)', marginTop: 4, fontWeight: 700 }}>
                {anexos.length} foto(s) selecionada(s)
              </div>
            )}
          </div>

          <button className="btn" onClick={salvar} disabled={salvando} style={{ padding: '13px' }}>
            {salvando ? 'Enviando…' : 'Enviar OS para a expedição'}
          </button>
        </div>

        {/* formas de armação (PNGs cadastrados pelo admin) */}
        <div className="card" style={{ position: 'sticky', top: 12 }}>
          <h3 className="card-title">Forma da Armação</h3>
          <div className="formas">
            {formas.filter(f => f.ativo).map(f => (
              <div key={f.id} className={`forma ${String(os.forma_armacao_id) === String(f.id) ? 'sel' : ''}`}
                onClick={() => set('forma_armacao_id', String(os.forma_armacao_id) === String(f.id) ? '' : f.id)}>
                <span className="num">{f.numero}</span>
                {f.imagem_url
                  ? <img src={f.imagem_url} alt={f.descricao || `Forma ${f.numero}`} />
                  : <span style={{ fontSize: 13, color: 'var(--cinza)' }}>{f.descricao || `Forma ${f.numero}`}</span>}
              </div>
            ))}
            {!formas.length && <div style={{ fontSize: 13, color: 'var(--cinza)' }}>Nenhuma forma cadastrada. O admin cadastra os PNGs em "Formas de Armação".</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
